<template>
   <el-tabs type="border-card" style="height:auto">
    <el-tab-pane label="类目列表" style="height:auto" >
      <div style="margin-top:16px;" >
        <el-form :inline="true" :model="categoryForm" class="demo-form-inline">
          <el-form-item label="类目名称">
            <el-input size="mini" v-model.trim="categoryForm.name" placeholder="类目名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-top:16px;">
        <el-table
          :data="data" border>
          <el-table-column
            fixed
            prop="id"
            label="ID编号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="name"
            label="类目名称"
            width="360">
          </el-table-column>
          <el-table-column
            prop="productCount"
            label="产品数量"
            width="120">
          </el-table-column>
          <el-table-column
            prop="items"
            label="显示属性">
          </el-table-column>
          <el-table-column
            prop="createDate"
            label="创建时间">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="160">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../common/util/pagination";

export default {
  data() {
    return {
      data: [],
      optionItem: {},
      categoryForm: {
        categoryName: '',
        token: this.user.getToken()
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      }
    };
  },
  components: {
    pagination
  },
  methods: {
    handleEdit(row) {
      this.$router.push({name:'categoryEditor',params:row})
    },
    getWithdrawData: function() {
      this.optionItem = this.common.extend(this.categoryForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/category/list',
        this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        });
    },
    onSubmit: function() {
      this.pagination.pageNum = 1
      this.getWithdrawData()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getWithdrawData()
    }
  },
  mounted: function() {
    this.getWithdrawData();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/category/category.vue